<template>
  <section id="compare" class="compare">
    <h2>Compare Our Plans</h2>
    <p style="margin-top: -0.5rem">
      See which plan is best for you by comparing the features offered.
    </p>

    <PricingCompareMobile v-if="isSmallerScreen" />
    <PricingCompareTable v-else />
  </section>
</template>

<script>
import { useMediaQuery } from '@vueuse/core';
import { ref, watch } from '@nuxtjs/composition-api';

import PricingCompareTable from '@/components/pricing/pricing-compare-table';
import PricingCompareMobile from '@/components/pricing/pricing-compare-mobile';

export default {
  components: {
    PricingCompareTable,
    PricingCompareMobile,
  },

  setup() {
    const isSmallerScreen = ref(false);
    const isSmallerScreenQuery = useMediaQuery('(max-width: 543px)');

    watch(
      isSmallerScreenQuery,
      (val) => {
        isSmallerScreen.value = val;
      },
      {
        immediate: true,
      },
    );

    return {
      isSmallerScreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.compare {
  padding: 1rem 0;

  @media (min-width: 768px) {
    padding: 2rem 0;
    text-align: center;
  }
}
</style>
